
<template>
  <!--编辑社区功能-->
  <x-editAppFun></x-editAppFun>
</template>

<script>
import EditAppFun from '@/components/package/editAppFun.vue';
export default {
  components: {
    xEditAppFun: EditAppFun
  },
  name: 'editCommunityFun'
};
</script>
